import React, { useRef, useContext, useEffect } from 'react';
import AlloyMainDetails from './AlloyMainDetails';
import AlloyWheelSelection from './AlloyWheelSelection';
import { AlloyProcessStages } from './AlloyRepairRequestTypes';
import AlloyRepairRequestSummary from './AlloyRepairRequestSummary';
import LoadingContainer from '../../common/loadingContainer/LoadingContainer';
import ProgressBar from '../../common/progressBar/ProgressBar';
import { AlloyRepairRequestContext } from '../../../context/AlloyRepairRequestContext';
import { t } from 'i18next';

const AlloyRepairRequest = (): JSX.Element => {
    const errorContainerRef = useRef<null | HTMLDivElement>(null);
    const scrollDivRef = useRef<null | HTMLDivElement>(null);
    const cancelConfirmText = t('cancel_alloy_confirm_text');

    const { alloyRepairRequest, progressBarItems } = useContext(
        AlloyRepairRequestContext
    );

    const { alloyStage, isLoadingOnSubmission, hasErrors, scrollToAddress } =
        alloyRepairRequest;

    useEffect(() => {
        if (errorContainerRef.current) {
            if (hasErrors) {
                errorContainerRef.current?.scrollIntoView({
                    block: 'end',
                    behavior: 'smooth'
                });
            }
        }

        if (!hasErrors) {
            window.scrollTo(0, 0);
        }
    }, [hasErrors]);

    useEffect(() => {
        if (!scrollToAddress) scrollDivRef.current?.scrollIntoView();
    }, [alloyStage]);
    return (
        <>
            <div ref={scrollDivRef}></div>
            <ProgressBar
                id='alloyProgressBar'
                progressBarItems={progressBarItems}
            />
            {alloyStage === AlloyProcessStages.General && (
                <AlloyMainDetails cancelConfirmText={cancelConfirmText} />
            )}
            {alloyStage === AlloyProcessStages.WheelSelection && (
                <AlloyWheelSelection cancelConfirmText={cancelConfirmText} />
            )}
            {alloyStage === AlloyProcessStages.Summary && (
                <LoadingContainer
                    loading={isLoadingOnSubmission}
                    message={t('registering_requests')}>
                    <AlloyRepairRequestSummary
                        cancelConfirmText={cancelConfirmText}
                    />
                </LoadingContainer>
            )}
            <div ref={errorContainerRef}></div>
        </>
    );
};

export default AlloyRepairRequest;
